import { motion } from "framer-motion";
import { Truck, Scale, Banknote } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";

const STEPS = [
  { n: "1", title: "BRING YOUR SCRAP", text: "Bring your qualifying scrap metal to our Ashley yard.", Icon: Truck },
  { n: "2", title: "WE WEIGH & GRADE IT", text: "Your material is weighed and evaluated by type and grade. Our scales are visible.", Icon: Scale },
  { n: "3", title: "GET PAID", text: "Get paid for your scrap based on today's market.", Icon: Banknote },
];

export const HowItWorks = () => (
  <section className="bg-zinc-100 py-20 sm:py-28" data-testid="how-it-works-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <SectionTag number="03" label="Process" />
        <h2 className="font-heading text-4xl sm:text-5xl text-zinc-950 tracking-tight">HOW IT WORKS</h2>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-4">
        {STEPS.map((step, i) => (
          <motion.div
            key={step.n}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.55, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className="bg-white border border-zinc-200 p-8 relative overflow-hidden group hover:border-zinc-950 transition-colors"
            data-testid={`how-it-works-step-${step.n}`}
          >
            <span className="font-heading text-8xl text-zinc-100 absolute -top-3 right-2 select-none group-hover:text-red-100 transition-colors">
              {step.n}
            </span>
            <div className="relative">
              <div className="h-12 w-12 bg-zinc-950 flex items-center justify-center mb-6 group-hover:bg-red-700 transition-colors">
                <step.Icon className="h-6 w-6 text-white" />
              </div>
              <h3 className="font-heading text-2xl text-zinc-950 tracking-wide">{step.title}</h3>
              <p className="mt-3 text-zinc-600">{step.text}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
